(() => {
  const formSelector = ".js-instore-try-on-form";
  const placementSelector = "[data-instore-try-on-placement]";
  const triggerSelector = ".js-instore-try-on-trigger";
  const shortDescriptionSelector = ".product-short-description.rte";
  const visibleFieldSelector =
    '[name="customer_name"], [name="customer_email"], [name="customer_phone"], [name="booking_date"], [name="booking_time"]';
  const defaultBookingHours = {
    earliest: "09:00",
    latest: "17:30",
    thursdayLatest: "18:30",
    sundayEarliest: "",
    sundayLatest: "",
  };
  const bookingHoursByMarketId = {
    "13861054": {
      label: "AU",
      earliest: "09:30",
      latest: "17:00",
      thursdayLatest: "18:00",
      sundayEarliest: "",
      sundayLatest: "",
    },
    "44316819646": {
      label: "UK",
      earliest: "10:30",
      latest: "17:00",
      thursdayLatest: "17:00",
      sundayEarliest: "12:30",
      sundayLatest: "16:00",
    },
    "44316786878": {
      label: "US",
      earliest: "11:30",
      latest: "18:00",
      thursdayLatest: "18:00",
      sundayEarliest: "12:30",
      sundayLatest: "17:00",
    },
  };

  function setFormValue(form, name, value) {
    const field = form.querySelector(`[name="${name}"]`);
    if (field) field.value = value || "";
  }

  function getBookingEndpoint(form) {
    return (
      form.dataset.bookingEndpoint ||
      window.TT_INSTORE_BOOKING_ENDPOINT ||
      window.instoreBookingEndpoint ||
      ""
    );
  }

  function parseCookieValue(cookieValue) {
    if (!cookieValue) return "";

    try {
      return decodeURIComponent(cookieValue);
    } catch (error) {
      return cookieValue;
    }
  }

  function getCookieValue(name) {
    const cookies = document.cookie.split(";");

    for (const cookie of cookies) {
      const trimmedCookie = cookie.trim();
      const separatorIndex = trimmedCookie.indexOf("=");

      if (separatorIndex === -1) continue;

      const cookieName = trimmedCookie.slice(0, separatorIndex);
      const cookieValue = trimmedCookie.slice(separatorIndex + 1);

      if (cookieName === name) return parseCookieValue(cookieValue);
    }

    return "";
  }

  function normalizeGclid(value) {
    if (!value) return "";

    const decodedValue = parseCookieValue(value);
    const gclAwParts = decodedValue.split(".");

    return gclAwParts.length > 1 ? gclAwParts[gclAwParts.length - 1] : decodedValue;
  }

  function getGclidFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const standardGclid = urlParams.get("gclid");

    if (standardGclid) return standardGclid;

    const fallbackMatch = window.location.search.match(/[?&]gclid[-_=]([^&]+)/i);

    return fallbackMatch ? fallbackMatch[1] : "";
  }

  function getBookingGclid() {
    if (typeof getTrackingCookies === "function") {
      const trackingCookies = getTrackingCookies();

      if (trackingCookies?.gclid) return trackingCookies.gclid;
    }

    return normalizeGclid(
      getGclidFromUrl() ||
        getCookieValue("gclid") ||
        getCookieValue("_gcl_aw") ||
        getCookieValue("_gclid")
    );
  }

  function getBookingPayload(form) {
    const formData = new FormData(form);
    const payload = Object.fromEntries(formData.entries());

    payload.gclid = payload.gclid || getBookingGclid();
    payload.page_url = window.location.href;
    payload.submitted_at_client = new Date().toISOString();
    payload.timezone = payload.timezone || "Australia/Melbourne";
    payload.user_agent = window.navigator.userAgent;

    return payload;
  }

  function showBookingMessage(form, message, isError = false) {
    const messageElement = form.querySelector(".js-instore-try-on-message");
    if (!messageElement) return;

    messageElement.textContent = message;
    messageElement.hidden = false;
    messageElement.classList.toggle("is-error", isError);
    messageElement.classList.toggle("is-success", !isError);
  }

  function setSubmitButtonLabel(button, message) {
    const label = button?.querySelector("span");

    if (label) {
      label.textContent = message;
    } else if (button) {
      button.textContent = message;
    }
  }

  function padCalendarValue(value) {
    return String(value).padStart(2, "0");
  }

  function formatCalendarDate(date) {
    return [
      date.getFullYear(),
      padCalendarValue(date.getMonth() + 1),
      padCalendarValue(date.getDate()),
      "T",
      padCalendarValue(date.getHours()),
      padCalendarValue(date.getMinutes()),
      "00",
    ].join("");
  }

  function escapeCalendarText(value) {
    return String(value || "")
      .replace(/\\/g, "\\\\")
      .replace(/\n/g, "\\n")
      .replace(/,/g, "\\,")
      .replace(/;/g, "\\;");
  }

  function getBookingStartDate(payload) {
    const [year, month, day] = String(payload.booking_date || "").split("-").map(Number);
    const [hour, minute] = String(payload.booking_time || "").split(":").map(Number);

    if (!year || !month || !day || Number.isNaN(hour) || Number.isNaN(minute)) return null;

    return new Date(year, month - 1, day, hour, minute, 0);
  }

  function buildCalendarFile(payload) {
    const startDate = getBookingStartDate(payload);

    if (!startDate) return null;

    const endDate = new Date(startDate.getTime() + 30 * 60 * 1000);
    const title = "Try-on booking at Time+Tide";
    const description = [
      payload.product_title,
      payload.variant_title,
      payload.variant_sku,
      payload.product_url,
    ].filter(Boolean).join("\\n");
    const calendarContent = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//Time+Tide//Try-on Booking//EN",
      "CALSCALE:GREGORIAN",
      "METHOD:PUBLISH",
      "BEGIN:VEVENT",
      `UID:${Date.now()}-${payload.product_id || "try-on"}@timeandtidewatches.com`,
      `DTSTAMP:${formatCalendarDate(new Date())}`,
      `DTSTART:${formatCalendarDate(startDate)}`,
      `DTEND:${formatCalendarDate(endDate)}`,
      `SUMMARY:${escapeCalendarText(title)}`,
      "LOCATION:Time+Tide",
      `DESCRIPTION:${escapeCalendarText(description)}`,
      "END:VEVENT",
      "END:VCALENDAR",
    ].join("\r\n");

    return new Blob([calendarContent], { type: "text/calendar;charset=utf-8" });
  }

  function showCalendarDownload(form, payload) {
    const calendarButton = form.querySelector(".js-instore-try-on-calendar");
    const calendarFile = buildCalendarFile(payload);

    if (!calendarButton || !calendarFile) return;

    if (calendarButton.dataset.objectUrl) {
      URL.revokeObjectURL(calendarButton.dataset.objectUrl);
    }

    const objectUrl = URL.createObjectURL(calendarFile);

    calendarButton.href = objectUrl;
    calendarButton.dataset.objectUrl = objectUrl;
    calendarButton.hidden = false;
  }

  function getLocalDateFromValue(value) {
    if (!value) return null;

    const [year, month, day] = value.split("-").map(Number);

    if (!year || !month || !day) return null;

    return new Date(year, month - 1, day);
  }

  function isSunday(dateValue) {
    const date = getLocalDateFromValue(dateValue);

    return date ? date.getDay() === 0 : false;
  }

  function isThursday(dateValue) {
    const date = getLocalDateFromValue(dateValue);

    return date ? date.getDay() === 4 : false;
  }

  function isValidTimeString(value) {
    return /^\d{2}:(?:00|30)$/.test(value);
  }

  function getFormMarketId(form) {
    return (
      form.dataset.marketId ||
      form.querySelector('[name="market_id"]')?.value ||
      ""
    );
  }

  function getMarketBookingHours(form) {
    return bookingHoursByMarketId[getFormMarketId(form)] || null;
  }

  function getConfiguredBookingTime(value, fallback) {
    return isValidTimeString(value) ? value : fallback;
  }

  function getOptionalBookingTime(value) {
    return isValidTimeString(value) ? value : "";
  }

  function getBookingHours(form) {
    const marketHours = getMarketBookingHours(form);
    const earliest = marketHours?.earliest ?? form.dataset.bookingEarliestTime ?? defaultBookingHours.earliest;
    const latest = marketHours?.latest ?? form.dataset.bookingLatestTime ?? defaultBookingHours.latest;
    const thursdayLatest = marketHours?.thursdayLatest ?? form.dataset.bookingThursdayLatestTime ?? latest;
    const sundayEarliest = marketHours?.sundayEarliest ?? form.dataset.bookingSundayEarliestTime ?? defaultBookingHours.sundayEarliest;
    const sundayLatest = marketHours?.sundayLatest ?? form.dataset.bookingSundayLatestTime ?? defaultBookingHours.sundayLatest;
    const resolvedEarliest = getConfiguredBookingTime(earliest, defaultBookingHours.earliest);
    const resolvedLatest = getConfiguredBookingTime(latest, defaultBookingHours.latest);

    return {
      earliest: resolvedEarliest,
      latest: resolvedLatest,
      thursdayLatest: getConfiguredBookingTime(thursdayLatest, resolvedLatest),
      sundayEarliest: getOptionalBookingTime(sundayEarliest),
      sundayLatest: getOptionalBookingTime(sundayLatest),
    };
  }

  function getBookingWindow(form, dateValue) {
    const hours = getBookingHours(form);
    const window = {
      label: "selected day",
      earliest: hours.earliest,
      latest: hours.latest,
      closed: false,
    };

    if (isSunday(dateValue)) {
      window.label = "Sunday";
      window.earliest = hours.sundayEarliest;
      window.latest = hours.sundayLatest;
    } else if (isThursday(dateValue)) {
      window.label = "Thursday";
      window.latest = hours.thursdayLatest;
    }

    window.closed = !window.earliest || !window.latest || window.earliest > window.latest;

    return window;
  }

  function isThirtyMinuteTimeSlot(timeValue) {
    return /^\d{2}:(?:00|30)$/.test(timeValue);
  }

  function isTimeInBookingWindow(form, dateValue, timeValue) {
    const bookingWindow = getBookingWindow(form, dateValue);

    return (
      !bookingWindow.closed &&
      isThirtyMinuteTimeSlot(timeValue) &&
      timeValue >= bookingWindow.earliest &&
      timeValue <= bookingWindow.latest
    );
  }

  function timeToMinutes(timeValue) {
    const [hours, minutes] = String(timeValue || "").split(":").map(Number);

    return hours * 60 + minutes;
  }

  function minutesToTime(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  }

  function formatTimeLabel(timeValue) {
    const [hour, minute] = timeValue.split(":").map(Number);
    const period = hour >= 12 ? "pm" : "am";
    const displayHour = hour % 12 || 12;

    return `${displayHour}:${String(minute).padStart(2, "0")}${period}`;
  }

  function buildTimeSlotOptions(form) {
    const timeField = form.querySelector('[name="booking_time"]');

    if (!timeField || timeField.tagName !== "SELECT" || timeField.dataset.bookingSlotsGenerated === "true") return;

    const hours = getBookingHours(form);
    const bookingWindows = [
      { earliest: hours.earliest, latest: hours.latest },
      { earliest: hours.earliest, latest: hours.thursdayLatest },
      { earliest: hours.sundayEarliest, latest: hours.sundayLatest },
    ].filter((window) => window.earliest && window.latest && window.earliest <= window.latest);
    const earliestMinutes = Math.min(...bookingWindows.map((window) => timeToMinutes(window.earliest)));
    const finalSlotMinutes = Math.max(...bookingWindows.map((window) => timeToMinutes(window.latest)));
    const placeholder = document.createElement("option");

    timeField.textContent = "";
    placeholder.value = "";
    placeholder.textContent = "Select a time";
    timeField.appendChild(placeholder);

    for (let minutes = earliestMinutes; minutes <= finalSlotMinutes; minutes += 30) {
      const timeValue = minutesToTime(minutes);
      const option = document.createElement("option");

      option.value = timeValue;
      option.textContent = formatTimeLabel(timeValue);
      timeField.appendChild(option);
    }

    timeField.dataset.bookingSlotsGenerated = "true";
  }

  function updateTimeSlotAvailability(form) {
    const dateField = form.querySelector('[name="booking_date"]');
    const timeField = form.querySelector('[name="booking_time"]');
    const bookingWindow = getBookingWindow(form, dateField?.value);

    if (!timeField) return;

    timeField.querySelectorAll("option[value]").forEach((option) => {
      if (!option.value) return;

      const isAvailable = !bookingWindow.closed &&
        option.value >= bookingWindow.earliest &&
        option.value <= bookingWindow.latest;

      option.disabled = !isAvailable;
      option.hidden = !isAvailable;
    });

    if (timeField.value && !isTimeInBookingWindow(form, dateField?.value, timeField.value)) {
      timeField.value = "";
    }
  }

  function validateBookingAvailability(form) {
    const dateField = form.querySelector('[name="booking_date"]');
    const timeField = form.querySelector('[name="booking_time"]');

    if (dateField) {
      dateField.setCustomValidity("");

      if (dateField.value && getBookingWindow(form, dateField.value).closed) {
        dateField.setCustomValidity("Try-on bookings are not available on this date.");
      }
    }

    if (timeField) {
      timeField.setCustomValidity("");

      if (timeField.value && !isTimeInBookingWindow(form, dateField?.value, timeField.value)) {
        const bookingWindow = getBookingWindow(form, dateField?.value);
        const message = bookingWindow.closed
          ? `Try-on bookings are not available on ${bookingWindow.label}s.`
          : `Try-on bookings are available between ${formatTimeLabel(bookingWindow.earliest)} and ${formatTimeLabel(bookingWindow.latest)}.`;

        timeField.setCustomValidity(message);
      }
    }

    return form.checkValidity();
  }

  function pushBookingConversionEvent(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "book_try_on_submit",
      conversion_selector: "book-try-on-form",
      product_id: payload.product_id,
      variant_id: payload.variant_id,
      product_price_cents: payload.product_price_cents,
      currency: payload.currency,
      gclid_present: Boolean(payload.gclid),
    });
  }

  function clearVisibleBookingFields(form) {
    form.querySelectorAll(visibleFieldSelector).forEach((field) => {
      field.value = field.name === "customer_phone" ? field.defaultValue : "";
    });
  }

  function updateBookingFormVariant(variant) {
    if (!variant) return;

    document.querySelectorAll(formSelector).forEach((form) => {
      setFormValue(form, "variant_id", variant.id);
      setFormValue(form, "variant_title", variant.title);
      setFormValue(form, "variant_sku", variant.sku);
      setFormValue(form, "product_price_cents", variant.price);

      const productUrl = form.dataset.productUrl;
      if (productUrl) {
        setFormValue(form, "product_url", `${productUrl}?variant=${variant.id}`);
      }
    });
  }

  function setMinimumBookingDates() {
    const today = new Date();
    const localDate = new Date(today.getTime() - today.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);

    document.querySelectorAll(`${formSelector} [name="booking_date"]`).forEach((field) => {
      field.min = localDate;
    });

    document.querySelectorAll(`${formSelector} [name="booking_time"]`).forEach((field) => {
      if (field.type === "time") {
        const form = field.closest(formSelector);
        const hours = form ? getBookingHours(form) : defaultBookingHours;

        field.min = hours.earliest;
        field.max = hours.latest;
      }
    });
  }

  function bindBookingValidation(form) {
    const dateField = form.querySelector('[name="booking_date"]');
    const timeField = form.querySelector('[name="booking_time"]');

    [dateField, timeField].forEach((field) => {
      if (!field || field.dataset.bookingValidationBound === "true") return;

      field.dataset.bookingValidationBound = "true";
      field.addEventListener("input", () => {
        updateTimeSlotAvailability(form);
        validateBookingAvailability(form);
      });
      field.addEventListener("change", () => {
        updateTimeSlotAvailability(form);
        validateBookingAvailability(form);
      });
    });

    buildTimeSlotOptions(form);
    updateTimeSlotAvailability(form);
  }

  function bindBookingForms() {
    placeBookingForm();
    bindTryOnTriggers();
    setMinimumBookingDates();

    document.querySelectorAll(formSelector).forEach((form) => {
      if (form.dataset.bookingBound === "true") return;

      form.dataset.bookingBound = "true";
      bindBookingValidation(form);

      form.addEventListener("submit", async (event) => {
        event.preventDefault();

        validateBookingAvailability(form);

        if (!form.reportValidity()) return;

        const endpoint = getBookingEndpoint(form);
        if (!endpoint) {
          showBookingMessage(
            form,
            "Booking is not available yet. Please contact us to arrange a try-on.",
            true
          );
          return;
        }

        const submitButton = form.querySelector('[type="submit"]');
        const payload = getBookingPayload(form);
        const originalSubmitLabel = submitButton?.querySelector("span")?.textContent || submitButton?.textContent || "";

        setFormValue(form, "gclid", payload.gclid);
        form.classList.add("is-submitting");
        if (submitButton) {
          submitButton.disabled = true;
          setSubmitButtonLabel(submitButton, "Sending booking");
        }

        try {
          await fetch(endpoint, {
            method: "POST",
            mode: "no-cors",
            keepalive: true,
            headers: {
              "Content-Type": "text/plain;charset=utf-8",
            },
            body: JSON.stringify(payload),
          });

          pushBookingConversionEvent(payload);
          clearVisibleBookingFields(form);
          setSubmitButtonLabel(submitButton, "Your booking is confirmed");
          showCalendarDownload(form, payload);
        } catch (error) {
          console.error("Failed to send try-on booking", error);
          setSubmitButtonLabel(submitButton, originalSubmitLabel || "Book a Try-on");
          showBookingMessage(
            form,
            "We could not send your booking. Please try again or contact us.",
            true
          );
        } finally {
          form.classList.remove("is-submitting");
          if (submitButton) {
            submitButton.disabled = false;
          }
        }
      });
    });
  }

  function placeBookingForm() {
    const formPlacement = document.querySelector(placementSelector);
    const shortDescription = document.querySelector(shortDescriptionSelector);

    if (!formPlacement || !shortDescription) return;
    if (formPlacement.nextElementSibling === shortDescription) return;

    shortDescription.parentNode.insertBefore(formPlacement, shortDescription);
  }

  function bindTryOnTriggers() {
    document.querySelectorAll(triggerSelector).forEach((trigger) => {
      if (trigger.dataset.tryOnTriggerBound === "true") return;

      trigger.dataset.tryOnTriggerBound = "true";

      trigger.addEventListener("click", () => {
        const container = trigger.closest(placementSelector);
        const panelId = trigger.getAttribute("aria-controls");
        const panel = panelId ? document.getElementById(panelId) : null;

        if (!container || !panel) return;

        panel.hidden = false;
        trigger.setAttribute("aria-expanded", "true");
        container.classList.add("is-expanded");

        window.requestAnimationFrame(() => {
          const headerOffset = 90;
          const panelTop = panel.getBoundingClientRect().top + window.pageYOffset;

          window.scrollTo({
            top: Math.max(panelTop - headerOffset, 0),
            behavior: "smooth",
          });
        });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", bindBookingForms);
  document.addEventListener("shopify:section:load", bindBookingForms);
  document.addEventListener("product:variant-change", (event) => {
    updateBookingFormVariant(event.detail?.variant);
  });
})();
